import React from "react";
import { SFUseStyled, SFMoreMenu } from "@sf-core";

const { styled } = SFUseStyled();

const CardStyled = styled(
  "div",
  {}
)(({ theme }) => ({
  background: "linear-gradient(180deg, #2E2E38 0%, #23232F 100%)",
  color: theme.palette.white.main,
  boxShadow: "0px 10px 40px 0px #00000026",
  borderRadius: 6,
  position: "relative",
  //height: 95,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  minHeight: 64,
  padding: theme.spacing(2),
  ".card-title": {
    fontSize: 14,
  },
  ".card-container": {
    width: "100%",
  },
  ".MuiIconButton-root.more-button": {
    color: theme.palette.white.main,
    position: "absolute",
    top: 0,
    right: 0,
  },
}));

const SFCard = ({ title, actions, children }) => {
  return (
    <CardStyled>
      <div className="card-container">
        <div class="card-title">{title}</div>
        <SFMoreMenu items={actions} />
        {children}
      </div>
    </CardStyled>
  );
};

export default SFCard;
